const collapseText = () => {
  const containers = document.querySelectorAll('.js-collapse');

  function toggleButton(container) {
    const button = container.parentElement.querySelector('.js-collapse-button');

    button.addEventListener('click', event => {
      event.preventDefault();

      if (container.classList.contains('u-overflow-visible')) {
        container.classList.remove('u-overflow-visible');
        button.classList.add('is-collapsed');
      } else {
        container.classList.add('u-overflow-visible');
        button.classList.remove('is-collapsed');
      }
    });
  }

  function checkOverflow(entries) {
    entries.forEach(item => {
      const text = item.target.querySelector('.js-collapse-content');
      const button = item.target.parentElement.querySelector(
        '.js-collapse-button',
      );

      if (text.getBoundingClientRect().height > item.contentRect.height) {
        button.classList.remove('u-hidden');
        item.target.classList.add('is-overflow');
      }
    });
  }

  const resizeText = new ResizeObserver(entries => {
    checkOverflow(entries);
  });

  containers.forEach(container => {
    resizeText.observe(container);
    toggleButton(container);
  });
};

export default collapseText;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/trade-gov-chisel/src/scripts/modules/collapseText.js